/**
 * ProfileGate — blocks protected routes until the guardian profile is complete.
 *
 * The server decides what is missing (`missingFields`, plan §3.2). There is
 * no skip and no kiosk exception (plan §3.1, §11 D3/D5); the only ways out are
 * completing the form or signing out. Fails open when the backend does not
 * send `missingFields` (older backend / partial rollback).
 */
import React from 'react';
import { useAuthContext } from '../../contexts/AuthContext';
import GuardianProfileCompletion from './GuardianProfileCompletion';

const ProfileGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { guardian } = useAuthContext();
  const missing = guardian?.missingFields ?? [];
  if (!guardian || missing.length === 0) return <>{children}</>;
  return <GuardianProfileCompletion missing={missing} />;
};

export default ProfileGate;
